module.exports = __webpack_public_path__ + "media/images/clock-icon-5a8b2829c055bf25067a139b438438ab.svg";